import { type AsyncState, Status } from '@essent/common';
import type { PostHomebatteryV1Response } from '@integration/api-client/feh';
import { createReducer, on } from '@ngrx/store';
import type { ScLinkField } from '@core/jss-models';
import { FehApiActions } from '@feh/shared-api';

import {
  resetSubmitState,
  setRedirectUrl,
} from './homebattery-advice-form.actions';

export const homebatteryAdviceFormSelectorKey = 'homebattery-advice-form';

export type HomeBatteryAdviceFormSubmitState =
  AsyncState<PostHomebatteryV1Response>;

export interface HomeBatteryAdviceFormState {
  submitState: HomeBatteryAdviceFormSubmitState;
  redirectUrl: ScLinkField | null;
}

export const initialHomebatteryAdviceFormState: HomeBatteryAdviceFormState = {
  submitState: { status: Status.IDLE },
  redirectUrl: null,
};

/**
 * Only update when actionId belongs to homebattery advice form
 */
function updateOrIgnore<T>(actionId: unknown, oldState: T, newState: T): T {
  return actionId === homebatteryAdviceFormSelectorKey ? newState : oldState;
}

const apiActions = FehApiActions.postHomebatteryV1;

export const homebatteryAdviceFormReducer = createReducer(
  initialHomebatteryAdviceFormState,
  on(apiActions.requestAction, (state, { actionId }) =>
    updateOrIgnore(actionId, state, {
      ...state,
      submitState: { status: Status.PENDING },
    })
  ),
  on(apiActions.errorAction, (state, { actionId, payload }) =>
    updateOrIgnore(actionId, state, {
      ...state,
      submitState: { status: Status.ERROR, error: payload },
    })
  ),
  on(apiActions.successAction, (state, { actionId }) =>
    updateOrIgnore(actionId, state, {
      ...state,
      submitState: { status: Status.SUCCESS },
    })
  ),
  on(setRedirectUrl, (state, { redirectUrl }) => {
    return {
      ...state,
      redirectUrl,
    };
  }),
  on(resetSubmitState, (state) => {
    return {
      ...state,
      submitState: initialHomebatteryAdviceFormState.submitState,
    };
  })
);
